import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { getTermFromState } from '../../redux/selectors/i18n'
import Title from '../../components/Title'
import { appHasError, getErrorMessage, getErrorTitle } from '../../redux/selectors/errors';
import { eimCodeError, getReferrerURLParam, getDestinationURLParam } from '../../redux/selectors/helios';
import ErrorMessage from '../ErrorMessage';
import CTAButton from '../../components/CTAButton';
import { createLocateARetailerURL, createRequestAQuoteURL } from '../../redux/selectors/paymentOptions';
import { geti18n } from '../../utils';

class ErrorHandler extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    hasError: PropTypes.bool.isRequired,
    errorMsg: PropTypes.string.isRequired,
    errorTitle: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    errorColor: PropTypes.string,
    heliosConfigError: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.bool
    ]).isRequired,
    heliosErrorMessage: PropTypes.string,
    locateARetailerText: PropTypes.string,
    requestAQuoteText: PropTypes.string,
    destinationURL: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.bool
    ]).isRequired,
    referrerURL: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.bool
    ]).isRequired,
    locateARetailerURL: PropTypes.string,
    requestAQuoteURL: PropTypes.string
  };
  static defaultProps = {
    errorColor: '#fff',
    heliosErrorMessage: geti18n('fetchErrors.eimCode'),
    locateARetailerText: geti18n('offerPanel.summaryPanel.retailerButton'),
    requestAQuoteText: geti18n('offerPanel.summaryPanel.quoteButton'),
    locateARetailerURL: '',
    requestAQuoteURL: ''
  };
  renderErrorMessage() {
    const {
      children,
      hasError,
      errorMsg,
      errorTitle,
      title,
      description,
      errorColor,
      heliosConfigError,
      heliosErrorMessage,
      locateARetailerText,
      requestAQuoteText,
      destinationURL,
      referrerURL,
      locateARetailerURL,
      requestAQuoteURL
    } = this.props;
    if (!hasError && !heliosConfigError) {
      return children;
    }

    const retailerURL = referrerURL || locateARetailerURL;
    const quoteURL = destinationURL || requestAQuoteURL;
    // Helios Error on Configurator - EimCode does not map properly
    const heliosError = (
      <div className="model-line-container small-10 small-centered margin-top-large">
        <Title title={title} description={description} />
        <ErrorMessage title={errorTitle} message={heliosErrorMessage} errorColor={errorColor} />
        <div className="error-ctas">
          <CTAButton title={locateARetailerText} url={retailerURL} linkName="LOCATE_A_DEALER" className="secondary" />
          <CTAButton title={requestAQuoteText} url={quoteURL} linkName="REQUEST_A_QUOTE" />
        </div>
      </div>
    );
    // Default Error
    const gridError = (<div className="model-line-container small-10 small-centered margin-top-large">
      <Title title={title} description={description} />
      <ErrorMessage title={errorTitle} message={errorMsg} errorColor={errorColor} />
    </div>);

    return heliosConfigError ? heliosError : gridError;
  }
  render() {
    return this.renderErrorMessage();
  }
}

const mapStateToProps = state => ({
  hasError: appHasError(state),
  errorMsg: getErrorMessage(state),
  errorTitle: getErrorTitle(state),
  title: getTermFromState(state, 'titlePanel.title'),
  description: getTermFromState(state, 'titlePanel.description'),
  heliosConfigError: eimCodeError(state),
  locateARetailerURL: createLocateARetailerURL(state),
  requestAQuoteURL: createRequestAQuoteURL(state),
  referrerURL: getReferrerURLParam(state),
  destinationURL: getDestinationURLParam(state)

});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ErrorHandler);




/** WEBPACK FOOTER **
 ** ./src/components/ErrorHandler/index.js
 **/